export default __webpack_public_path__ + "static/media/search-landlord.f9caa167.svg";